/**
 * ApexCharts global theme — Stock Jockey design system
 *
 * ApexCharts theming works via the global `window.Apex` object.
 * Any option set here becomes the default for every chart in the app.
 * Individual chart option objects can still override on a per-chart basis.
 *
 * Docs: https://apexcharts.com/docs/options/chart/
 */

// ─── Monochrome portfolio palette ────────────────────────────────────────────
// Eleven shades of the primary brand green (#08d167), darkening in steps.
// Using fixed shades (not CSS variables) because ApexCharts sets SVG `fill`
// attributes — CSS custom properties aren't resolved inside SVG attributes in
// all browsers.
// Shades are evenly spaced in lightness so each segment is clearly distinct
// on both sj-dark and sj-light backgrounds.
export const PORTFOLIO_PALETTE = [
  '#08d167',
  '#07bd5d',
  '#06aa53',
  '#05974a',
  '#048541',
  '#037338',
  '#036130',
  '#024f28',
  '#023e21',
  '#012d19',
  '#001d11',
]

// Ordered red palette for negative-return heat maps.
// Index 0 is used for the most negative rank.
export const NEGATIVE_RETURN_PALETTE = [
  '#7f1d1d',
  '#9b1f1f',
  '#b91c1c',
  '#cf2020',
  '#dc2626',
  '#e53935',
  '#ef4444',
  '#f16363',
  '#f87171',
  '#fb8f8f',
  '#fca5a5',
]

// ─── Line / area chart palette ────────────────────────────────────────────────
// Brand-led sequence: primary green, accent cyan, secondary, then supporting.
export const CHART_PALETTE = [
  '#08d167', // primary
  '#0bdfff', // accent (winner's circle cyan)
  '#05ab71', // secondary
  '#f59e0b', // amber
  '#a78bfa', // violet
  '#f97316', // orange
  '#94a3b8', // slate
  '#f43f5e', // error red
]

// ─── Global defaults ──────────────────────────────────────────────────────────
export function applyApexTheme() {
  window.Apex = {
    chart: {
      fontFamily: '"Be Vietnam Pro", sans-serif',
      background:  'transparent',
      toolbar:     { show: false },
      animations:  { enabled: false },
    },
    colors: CHART_PALETTE,
    stroke: {
      // Line charts: smooth curves. Individual charts can override width.
      curve: 'smooth',
    },
    tooltip: {
      style: {
        fontSize:   '12px',
        fontFamily: '"Be Vietnam Pro", sans-serif',
      },
    },
    legend: {
      fontFamily: '"Be Vietnam Pro", sans-serif',
      fontSize:   '12px',
    },
    dataLabels: {
      enabled: false,
    },
  }
}
